
import React, { FC, useEffect } from 'react'
import cnBind from 'classnames/bind'
import { useStoreon } from 'storeon/react'

import Select, { TOption } from '@/components/Select'
import { IFlyingListEntry } from '@/types'
import { Events, State } from '@/interfaces'
import useModal from '@/hooks/useModal';
import { MODALS_NAMES } from '@/const/modals';
import { SelectOptionsSession } from '../const/intex'
import { entryMarks } from '../../Schedule/const';

import styles from '../styles/index.module.scss'
import { colourStyles, colourStylesSession } from '../styles/select'

interface ITableUserInfoProps extends IFlyingListEntry {
  isFirst?: boolean
  intervalId: number
  lengthFlyingEntries: number
  exit_time: string | null
  entry_time: string | null
}
export const TableUserInfo: FC<ITableUserInfoProps> = ({
  isFirst,
  id,
  intervalId,
  fly_session_minutes,
  customer,
  session_minutes,
  tariff,
  lengthFlyingEntries,
  entries,
  instructor,
  controller,
  is_not_actual,
  exit_time,
  entry_time,
}) => {
  const {
    dispatch,
    instructorOptions
  } = useStoreon<State, Events>(
    'instructorOptions'
  );
  const [maxCheck, setMaxCheck] = React.useState(entries ?? 0);
  const [flySessionMinutes, setFlySessionMinutes] = React.useState(fly_session_minutes);

  const cn = cnBind.bind(styles);

  const handleChangeFlyingInfo = ({ params }: { params: Record<string, any> }) => {
    dispatch('flyingListEntry/update', { intervalId, id, params })
  }

  const onClickCheckBox = (e: React.ChangeEvent<HTMLInputElement>, id: number) => {
    let countEntries = 0

    if (e.target.checked) {
      countEntries = id
    }

    if (!e.target.checked) {
      countEntries = id - 1
    }

    handleChangeFlyingInfo({
      params: {
        entries: countEntries
      }
    })
  }

  const availableOptionsSession = SelectOptionsSession.filter((item) => session_minutes % item.value === 0 || item.value === 0);

  const availableEntries = flySessionMinutes === null || flySessionMinutes === 0 ? 0 : session_minutes / flySessionMinutes;

  const isAvailableCheckbox = (id: number) => {
    return id <= availableEntries && flySessionMinutes !== null
  }

  const { openModal } = useModal();

  const onChangeExitTime = (exit_time: string): void => {
    dispatch('flyingListTimeIntervals/update', { id: intervalId, params: { exit_time } })
  }

  const onChangeEntryTime = ({ entry_time, instructor, controller }: { entry_time: string, instructor?: string | null, controller?: string | null }): void => {
    dispatch('flyingListTimeIntervals/update', { id: intervalId, params: { entry_time, instructor, controller } })
  }
  const openModalChangeTime = (type: 'exit' | 'entry'): void => {


    if (type === 'entry') {
      openModal(MODALS_NAMES.modalEntryTimeChange, { entry_time, onChangeEntryTime });
      return
    }

    if (entry_time===null) return;
    openModal(MODALS_NAMES.modalExitTimeChange, { exit_time, onChangeExitTime });
  }

  const handleChangeSessions = (newOption: TOption) => {
    if (newOption.value === 0) {
      setFlySessionMinutes(0);
    }else{
      setFlySessionMinutes(Number(newOption.value));
    }

    if (maxCheck > session_minutes / Number(newOption.value)) {
      setMaxCheck(session_minutes / Number(newOption.value));
      handleChangeFlyingInfo({
        params: {
          fly_session_minutes: newOption.value === 0 ? null : Number(newOption.value),
          entries: session_minutes / Number(newOption.value)
        }
      })
      return
    }

    handleChangeFlyingInfo({
      params: {
        fly_session_minutes: newOption.value === 0 ? null : Number(newOption.value),
        entries: newOption.value === 0 ? null : undefined
      }
    })

    if (newOption.value === 0) {
      setMaxCheck(0);
    }
  }

  useEffect(() => {
    setMaxCheck(entries ?? 0)
  }, [entries])

  return (
    <tr className={cn({
      [styles.body_row]: true,
      [styles['body_row--isChanged']]: is_not_actual
    })}>
      {/* ВРЕМЕННОЙ ИНТЕРВАЛ session_minutes */}
      <td className={styles.body_column}>
        <div className={styles.body_row__sessionMinutes}>
          <div className={styles.body_row__sessionMinutes__flyMins}>
            {session_minutes}
          </div>
        </div>
      </td>

      {/* КОНТРАГЕНТ customer */}
      <td
        className={styles.body_column}>
        <div className={styles.body_row__userAndTariff}>
          <div className={styles.body_row__userAndTariff__user}>
            <div className={styles.order__container}>
              <p className={styles.orders__user}>
                {customer.last_name} {customer.first_name}
              </p>
            </div>
          </div>

        </div>
      </td>
      {/* ТАРИФ tariff */}
      <td className={styles.body_column}>
        <p className={styles.body_row__tariff}>
          {tariff?.title}
        </p>
      </td>

      {/* СЕССИЯ session_minutes */}
      <td className={styles.body_column__session}>
        <Select
          styles={colourStylesSession}
          menuPosition='fixed'
          value={availableOptionsSession.find((item) => item.value === flySessionMinutes) ?? availableOptionsSession[0]}
          onChange={handleChangeSessions}
          isDisabled = {entry_time === null}
          options={availableOptionsSession} />
      </td>
      {/* ВРЕМЯ ПРИБЫЛИ entry_time */}
      {
        isFirst ? (
          <td rowSpan={lengthFlyingEntries} className={styles.time}>
            <div
            role='button'
            tabIndex={-1}
            className={styles.body_row__time_session}
            onClick={() => openModalChangeTime('entry')}
            >
              {entry_time || '-'}
            </div>
          </td>
        ) : null
      }

      {/* ВРЕМЯ ВЫХОДА exit_time */}
      {
        isFirst ? (
          <td rowSpan={lengthFlyingEntries} className={styles.time}>
            <div
            role='button'

            className={cn({
              [styles.body_row__time_session]: true},
              {[styles.body_row__time_session_disabled]: entry_time===null}
            )}
            onClick={() => openModalChangeTime('exit')}
            tabIndex={-1}
            >
              {exit_time || '-'}
            </div>
          </td>
        ) : null
      }

      {/* ИНТЕРВАЛ entries */}
      {
        entryMarks.map((row) => (
          <td align='center' key={row}>
            <div className={cn({
              [styles.body_row__interval_wrapper]: true,
              [styles.body_row__interval_wrapper_disabled]: !isAvailableCheckbox(Number(row))
            })}>
              {isAvailableCheckbox(Number(row))
                ?
                <input
                  type='checkbox'
                  checked={Number(row) <= maxCheck}
                  className={styles.body_row__interval}
                  onChange={(e) => { onClickCheckBox(e, Number(row)) }}
                  disabled = {entry_time === null}
                  />
                : null
              }
            </div>
          </td>
        ))
      }

      {/* ИНСТРУКТОР instructor */}
      <td>
        <Select
          styles={colourStyles}
          menuPosition='fixed'
          value={instructorOptions.find((item) => item.value === instructor)}
          options={instructorOptions}
          onChange={(newOption) => handleChangeFlyingInfo({ params: { instructor: newOption.value } })}
          isDisabled={entry_time === null}/>
      </td>
      {/* КОНТРОЛЛЕР controller */}
      <td>
        <Select
          styles={colourStyles}
          menuPosition='fixed'
          value={instructorOptions.find((item) => item.value === controller)}
          options={instructorOptions}
          onChange={(newOption) => handleChangeFlyingInfo({ params: { controller: newOption.value } })}
          isDisabled={entry_time === null}/>
      </td>
    </tr>
  )
}
